module.exports = "module.exports = __webpack_public_path__ + \"static/media/pageFooter.4ca0b118.template\";"